var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "tabs",
        _vm._l(_vm.enabledTabs, function(tab, index2) {
          return _c(
            "tab",
            { key: index2, attrs: { title: tab.label } },
            _vm._l(tab.fields, function(field, index) {
              return _c("timesheet-fieldset", {
                key: index,
                attrs: { layout: field },
                on: { change: _vm.onChange }
              })
            }),
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }